import { notify } from '../../actions/notifications';
import { fetchRecommendationsToggleFavorite } from '../../actions/recommendations';
import { TAddFavoriteResponse, fetchAddFavorite } from '../../repositories/favorites/v1/add-favorite';
import { ENotificationStyle } from '../../types/notifications';
import { EEntityType, TRecommendation } from '../../types/recommendation';
import { TThunkAction } from '../../types/redux';
import { trackAddToFavorite } from './tracking';

export const addToFavorite =
  ({ dealType, offerId, entityType }: TRecommendation, position: number): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, logger }) => {
    dispatch(fetchRecommendationsToggleFavorite({ offerId, isFavorite: true }));

    const label = `${dealType}/${entityType === EEntityType.OfferSuburban ? 'suburban' : 'flat'}`;

    trackAddToFavorite({ label, offerId, position });

    const showError = () => dispatch(notify('Не удалось добавить рекомендацию в избранное', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TAddFavoriteResponse = await fetchAddFavorite({
        httpApi,
        parameters: {
          dealType,
          entityId: offerId,
          entityType,
        },
      });

      if (statusCode !== 200) {
        dispatch(fetchRecommendationsToggleFavorite({ offerId, isFavorite: false }));

        showError();
        logger.warning(response.message || 'Fail to add recommendation to favorites');
      }
    } catch (e) {
      dispatch(fetchRecommendationsToggleFavorite({ offerId, isFavorite: false }));

      showError();
      logger.error(e, {
        description: 'Fail to add recommendation to favorites',
      });
    }
  };
